























import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../../shared/services/mixin";
import {Component, Prop, PropSync} from "vue-property-decorator";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import {WarehouseStore} from "@/modules/warehouses/store";
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";

@Component({
    name: 'WarehouseSuggestTranshipmentTable',
    components: {TooltipLabel, LadingStatusLabel}
})
export default class extends mixins(CommonMixin) {
    @Prop() dataSource!: any;
    @PropSync('form') formSync!: any;

    columns = [
        {
            title: "STT",
            dataIndex: "stt",
            key: "stt",
            width: 50
        },
        {
            title: "Mã vận đơn",
            dataIndex: "billLading.ladingCode",
            key: "ladingCode",
            width: 150,
            ellipsis: true
        },
        {
            title: "Tỉnh đến",
            dataIndex: "billLading.locationTo.province.name",
            key: "locationToProvince",
            width: 120,
            ellipsis: true
        },
        {
            title: "TL(g)",
            dataIndex: "billLading.weightTemp",
            key: "ladingWeight",
            width: 100,
            ellipsis: true,
            scopedSlots: { customRender: 'weightTemp' }
        },
        {
            title: "SK",
            dataIndex: "billLading.boxQuantity",
            key: "ladingBoxQuantity",
            width: 80,
            ellipsis: true
        },
        {
            title: "Dịch vụ",
            dataIndex: "billLading.freightService.serviceCode",
            key: "ladingFreightService",
            width: 100,
            ellipsis: true
        },
        {
            title: "DV_GTGT",
            dataIndex: "billLading.freightServiceAdds",
            key: "ladingFreightServiceAdd",
            scopedSlots: {customRender: 'ladingFreightServiceAdd'},
            width: 120,
            ellipsis: true
        },
        {
            title: "Thu tiền NN",
            dataIndex: "billLading.receiverCollect",
            key: "ladingReceiverCollect",
            scopedSlots: {customRender: 'ladingReceiverCollect'},
            width: 150,
            ellipsis: true
        }
    ];

    deleteWarehouse(id: number) {
        WarehouseStore.deleteWarehouse([id]);
        this.formSync.warehouseIds = this.formSync.warehouseIds.filter((warehouseId: number) => warehouseId != id);
    }

    onSelectChange(selectedRowKeys: string[]) {
        this.formSync.warehouseIds = selectedRowKeys as any;
    }
}
